/**
 * Utilities for scoreboard game strip.
 * @return {Object}     Utility functions to extract game strip information
 */

var browser = require('./browser.js');
var moment = require('moment');
var api = {};

// map for all default logos
var defaultLogos = {
    soccer: "http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/default-team-logo-500.png"
};

/**
 * Get logo for a sport
 * @param  {String} sport
 * @return {String}       url if found in defaultLogos object
 */
function getLogo(sport) {
    var logo = '';
    sport = sport || 'soccer';
    if (sport in defaultLogos) {
        logo = defaultLogos[sport];
    }
    //console.log('getLogo', logo);
    return logo;
}


function isOEmpty(input) {
    for(var prop in input) {
        if (input.hasOwnProperty(prop)){
            return false;
        }
    }
    return true;
}


/**
 * Get gamestatus from state
 * @param  {String} state pre/in/post
 * @return {String}       pregame/live/final/empty string
 */
api.getGameStatus = function(state) {
    // var state =
    var gameStatus = '';
    if (state === 'pre') {
        gameStatus = 'pregame';
    } else if (state === 'in') {
        gameStatus = 'live';
    } else if (state === 'post') {
        gameStatus = 'final';
    }
    return gameStatus;
};

/**
 * Get localtime from string.
 * On error, pass return dateString as is.
 */
api.getLocalTime = function(dateString) {
    try {
        api.utcOffset = api.utcOffset || moment.parseZone(new Date()).utcOffset();
        var timeZone = browser.call('espn_ui.Helpers.timezones.getCurrentTimezone') || '';
        return moment(dateString).utcOffset(api.utcOffset).format('h:mm a') + ' ' + timeZone;
    } catch (e) {
        return dateString;
    }
};

/**
 * From team object, get URL to team page.
 */
api.getTeamUrl = function(team) {
    var url = '';
    try {
        url = team.links[0].href;
    } catch (e) {}
    return url;
};

/**
 * Get team's logo if found else return default logo
 */
api.getTeamLogo = function(team, sport) {
    sport = sport || 'soccer';
    var teamLogo = team && team.logo || team && team.logos && team.logos[0] && team.logos[0].href || getLogo(sport);
    //console.info('teamLogo', teamLogo);
    return teamLogo;
};

/**
 * Get home and away team's information
 */
api.getTeamsInfo = function(homeTeam, awayTeam) {
    homeTeam = homeTeam || {};
    awayTeam = awayTeam || {};
    var teams = {
        home: {
            home: true,
            id: homeTeam.id,
            name: homeTeam.name,
            url: api.getTeamUrl(homeTeam),
            abbreviation: (homeTeam.abbreviation || '').slice(0,3),
            color: homeTeam.color ? '#' + homeTeam.color : '',
            links: (homeTeam.links && homeTeam.links || []).slice(1),
            logo: api.getTeamLogo(homeTeam),
            form: homeTeam && homeTeam.form
        },
        away: {
            home: false,
            id: awayTeam.id,
            name: awayTeam.name,
            url: api.getTeamUrl(awayTeam),
            abbreviation: (awayTeam.abbreviation || '').slice(0,3),
            color: awayTeam.color ? '#' + awayTeam.color : '',
            links: (awayTeam.links && awayTeam.links || []).slice(1),
            logo: api.getTeamLogo(awayTeam),
            form: awayTeam && awayTeam.form
        }
    };
    //console.info('getTeamsInfo', teams);
    return teams;
};

/**
 * Get scores of home and away teams
 */
api.getScores = function(home, away, showLinescores) {
    var homeLinescore = home.linescores && home.linescores[0] && home.linescores[0].displayValue;
    var awayLinescore = away.linescores && away.linescores[0] && away.linescores[0].displayValue;

    var homeScore = home.score ? (home.score + (homeLinescore && showLinescores ? '(' + homeLinescore + ')' : '')) : '';
    var awayScore = away.score ? (away.score + (awayLinescore && showLinescores ? '(' + awayLinescore + ')' : '')) : '';
    //console.info('homeScore, awayScore', homeScore, awayScore);
    return {
        home: homeScore,
        away: awayScore
    };
};

/**
 * Returns home-winner/away-winner class
 */
api.getWinnerClass = function(home, away) {
    var classSuffix = '-winner';
    // reversed the classNames, following the toolkit
    return (home.winner ? 'away' + classSuffix : (away.winner ? 'home' + classSuffix : ''));
};

/**
 * Get details for a game (goals, cards, clock, shotout)
 * @param  {Object} competitionDetails
 * @param  {Number} homeId             home team ID
 */
api.getGameDetails = function(competitionDetails, homeId) {
    var gameDetails = {
        home: {
            goals: [],
            discipline: []
        },
        away: {
            goals: [],
            discipline: []
        }
    };
    for (var i = 0, len = competitionDetails && competitionDetails.length; i < len; i++) {
        var detail = competitionDetails[i];
        //console.info('\ndetail', detail);
        var key = detail && detail.team && detail.team.id == homeId ? 'home' : 'away';
        if (detail.scoreValue === 1) {
            gameDetails[key].goals.push({
                athletesInvolved: detail.athletesInvolved,
                clock: detail.clock,
                ownGoal: detail.ownGoal,
                shootout: detail.shootout,
                penaltyKick: detail.penaltyKick
            });
        } else {
            gameDetails[key].discipline.push({
                redCard: detail.redCard,
                yellowCard: detail.yellowCard,
                clock: detail.clock,
                athletesInvolved: detail.athletesInvolved
            });
        }
    }
    return gameDetails;
};

/**
 * Get information for penalty tries. Penalty tries are displayed under tries.
 * There is no player name associated so use 'Penalty Try'.
 */
function getPenTries(e) {
    var info;
    if (e.hasOwnProperty('type') && e.type.description === 'penalty try') {
        //console.info('getPenTries', e);
        if (e.hasOwnProperty('clock') && e.clock.value) {
            info = {
                link: '',
                name: 'Penalty Try',
                rawClock: e.clock.value,
                times: []
            };
            var displayable = e.clock.displayValue || '';
            info.times.push(displayable);
        }
    }
    return info;
}

// Group stats for a player for an event type
function formattedRugbyStats(gameDetails) {

    // Template for data that will be returned
    var updated = {
        home: {
            tries: [],
            cons: [],
            pens: [],
            reds: [],
            drops: []
        },
        away: {
            tries: [],
            cons: [],
            pens: [],
            reds: [],
            drops: []
        }
    };

    // Iterate over home and away sides, side is home/away
    for (var side in gameDetails) {
        // side details is an object with 5 keys
        var sideDetails = gameDetails[side];
        // event type will be tries/cons/pens/reds/drops
        for (var eventType in sideDetails) {
            // List of events in that game
            var eventList = sideDetails[eventType];
            //console.info('eventList', eventList);

            /**
             * Iterate over all events of a type and build a data structure
             * d = { player name : {event details}}
             */

            var d = {};
            for (var j = 0; j < eventList.length; j++) {
                var currentEvent = eventList[j];
                //console.info(currentEvent.clock.displayValue, currentEvent);
                // Continue to next event if clock and athetes involved are missing
                if ((currentEvent.hasOwnProperty('athletesInvolved') === false &&
                    currentEvent.hasOwnProperty('participants') === false) ||
                    currentEvent.hasOwnProperty('clock') === false) {
                    // Check if it was a penalty try
                    var pt = getPenTries(currentEvent);
                    //console.info('pt', pt);
                    /**
                     * If it's a valid penalty try, associate with dummy
                     * player id.
                     */
                    //console.info('after getPenTries', pt);
                    /**
                     * For the first penalty try, assign it to d.pt.
                     * For subsequent penalty tries, append the penalty
                     * try time to an array in d.pt.times.
                     */
                    if (typeof pt !== 'undefined') {
                        if (d.hasOwnProperty('pt') && d.pt !== 'undefined') {
                            if (d.pt.hasOwnProperty('times') && pt.times && pt.times.length > 0) {
                                d.pt.times.push(pt.times[0]);
                            }
                        }
                        else{
                            d.pt = pt;
                        }
                    }
                    continue;
                }

                // Get player details
                var playerDetails = api.getPlayerNameLink(currentEvent);
                // Create aempty array to store references of clocks
                playerDetails.times = [];
                var playersInvolved = currentEvent.athletesInvolved ||  currentEvent.participants;
                var displayClock = currentEvent.clock.displayValue;
                var rawClock = currentEvent.clock.value;

                if (playersInvolved.length > 0 && typeof displayClock === 'string') {
                    var player = playersInvolved[0] && playersInvolved[0].athlete || playersInvolved[0];
                    // Proceed only if id and display name are present
                    if (player.hasOwnProperty('id') &&
                        player.hasOwnProperty('displayName')) {
                        //console.info('player', player);
                        if (d.hasOwnProperty(player.id) === false) {
                            d[player.id] = playerDetails;
                        }
                        d[player.id].times.push(displayClock);
                        d[player.id].rawClock = rawClock;
                        //console.info('d', d);
                    }
                }
            }
            // Push to array only if not empty
            if (isOEmpty(d) === false) {
                updated[side][eventType].push(d);
            }
        }
    }

    //console.info('\nupdated', updated);
    return updated;
}


// Get details for rugby
api.getRugbyDetails = function(details, homeId){
    // @todo - may not be required after api update, remove later.
    var pickStats = {
        'try': {
            aname: 'tries'
        },
        'conversion': {
            aname: 'cons'
        },
        'penalty goal': {
            aname: 'pens'
        },
        'red card': {
            aname: 'reds'
        },
        'drop goal': {
            aname: 'drops'
        },
        'penalty try' : {
            aname: 'tries'
        }
    };
    var gameDetails = {
        home: {
            tries: [],
            cons: [],
            pens: [],
            reds: [],
            drops: []
        },
        away: {
            tries: [],
            cons: [],
            pens: [],
            reds: [],
            drops: []
        }
    };

    for (var i = 0; i < details.length; i++) {
        var detail = details[i];
        if (detail.hasOwnProperty('team') === false) {
            //console.info('team missing so continuing to next detail');
            continue;
        }
        //console.info('detail', detail);
        var key = detail && detail.team.id == homeId ? 'home' : 'away';
        //console.info('key', key);
        // @todo - append to respective arrays based on event type
        if (detail.hasOwnProperty("type")) {
            var etype = detail.type;
            if (etype.hasOwnProperty('description')) {
                var desc = etype.description;
                /**
                 * If the desc was found in pickStats object, cache lookup
                 * object. Use the aname property to append to respective array
                 * name in home/away.
                 */
                if (desc in pickStats) {
                    var config = pickStats[desc];
                    var aname = config.aname;
                    //console.info('key', key, 'desc', desc, 'aname', aname);
                    gameDetails[key][aname].push(detail);
                }
            }

            // Forward compatibility
            if (etype.hasOwnProperty('text')) {
                var desc = etype.text;
                /**
                 * If the desc was found in pickStats object, cache lookup
                 * object. Use the aname property to append to respective array
                 * name in home/away.
                 */
                if (desc in pickStats) {
                    var config = pickStats[desc];
                    var aname = config.aname;
                    //console.info('key', key, 'desc', desc, 'aname', aname);
                    gameDetails[key][aname].push(detail);
                }
            }

        }
    }
    //console.info('gameDetails', gameDetails);

    // Group events for a player
    var updated = formattedRugbyStats(gameDetails);

    return updated;
};

/**
 * Get venue from competition
 * @return {Object} name and country of venue
 */
api.getVenueDetails = function(competition) {
    // Pick venue object
    var venue = competition && competition.venue || {};
    // Return name and country
    return {
        name: venue.fullName,
        country: venue.address && venue.address.country
    };
};


/**
 * Get note(description) in case game was settled on a 2 legged tie or
 * penalties.
 */
api.getGameNotes = function(competition, home, away) {
    //console.info('\ncompetition', competition);
    //console.info('home', home);
    //console.info('away', away);
    var note = competition && competition.leg && competition.leg.displayValue || '';
    // Get name of winner team
    var winnerName = home.winner ? home.team.displayName : away.team && away.team.displayName || null;
    // Declare winner/r'up score
    var winScore;
    var rupScore;
    if (home.aggregateScore !== away.aggregateScore) {
        winScore = home.winner ? home.aggregateScore : away.aggregateScore;
        rupScore = home.winner ? away.aggregateScore : home.aggregateScore;
        note = note + ' - ' + winnerName + ' win ' + winScore + '-' + rupScore + ' on aggregate';
    }
    if (home.shootoutScore !== away.shootoutScore) {
        winScore = home.winner ? home.shootoutScore : away.shootoutScore;
        rupScore = home.winner ? away.shootoutScore : home.shootoutScore;
        note = winnerName + ' win ' + winScore + '-' + rupScore + ' on penalties';
    }
    return note;
};

/**
 * Are home and away stats available?
 */
api.isStatsAvailable = function(home, away) {
    var homeStats = home.statistics || [];
    var awayStats = away.statistics || [];
    var available = false;
    if (homeStats.length && homeStats.length === awayStats.length) {
        for (var i = 0; i < homeStats.length; i++) {
            if (Number(homeStats[i].displayValue) > 0 || Number(awayStats[i].displayValue) > 0) {
                available = true;
                return available;
            }
        }
    }
    return available;
};

/**
 * Get home and away stats
 */
api.getStatsTableData = function(home, away) {

    var homeStats = home.statistics;
    var awayStats = away.statistics;

    var dataSet = {};

    for (var i = 0; i < homeStats.length; i++) {
        var homeStat = homeStats[i];
        var awayStat = awayStats[i];
        if (homeStat.abbreviation === awayStat.abbreviation) {
            dataSet[homeStat.abbreviation] = dataSet[homeStat.abbreviation] || {};
            dataSet[homeStat.abbreviation].name = homeStat.name;
            dataSet[homeStat.abbreviation].home = homeStat.displayValue;
            dataSet[homeStat.abbreviation].away = awayStat.displayValue;
        }
    }

    return dataSet;
};

/**
 * Returns date in DD/MM format
 * @param  {String} dateString
 * @return {String}
 */
api.getFormattedDate = function(dateString){
    try{
        api.utcOffset = api.utcOffset || moment.parseZone(new Date()).utcOffset();
        return moment(dateString).utcOffset(api.utcOffset).format('DD/MM');
    }catch(e){}
    return '';
};

/**
 * get Broadcasters
 * @return {Object}
 */
api.getBroadcasts = function(){
    // TODO
    return {
        external: true,
        url: '',
        name: ''
    };
};

// Get player's name and hyperlink
api.getPlayerNameLink = function(input) {
    // Default return value
    var playerDetails = {
        name: '',
        link: ''
    };
    //console.info('getPlayerNameLink', input);

    // Get scorer name and hyperlink
    if ('athletesInvolved' in input || 'participants' in input) {
        var playersInvolved = input.athletesInvolved || input.participants;
        if (playersInvolved.length > 0) {
            // Extract player name
            var player = playersInvolved[0].athlete || playersInvolved[0];
            if ('displayName' in player) {
                playerDetails.name = player.displayName;
            }
            // Extract player hyperlink
            if ('links' in player ) {
                var links = player.links;
                if (links.length > 0) {
                    var link = links[0];
                    if ('href' in link) {
                        playerDetails.link = link.href;
                    }
                }
            }
        }
    }
    return playerDetails;
};

// Get formatted clock - number'
api.getFormattedClock = function(input) {
    // Set defaults
    var clock = '';
    // Get clock info for the goal
    if ('clock' in input) {
        if ('displayValue' in input.clock) {
            clock = input.clock.displayValue;
        }
    }
    return clock;
};

api.getHeading = function(event){
    var name = event && event.league && event.league.name || '';
    var year = event && event.season && event.season.year || '';

    return name ? name + ' ' + event.season.year : '';
};

/**
 * Gets the active game status/time for the game strip
 * @param  {String} gameStatus
 * @param  {Object} status
 * @param  {Boolean} timeValid
 * @return {String}
 */
api.getActiveGameStatus = function(gameStatus, status, timeValid){

    var time    = '';
    var iTypeId = 0;

    // Not a valid time and game is not over so TBD
    if (typeof timeValid !== 'undefined' && !timeValid && gameStatus !== 'final') {
        return 'TBD';
    }

    // No status data so no time
    if(typeof status === 'undefined'){
        return '';
    }

    // Validate status id is available
    if(typeof status.type !== 'undefined' &&
       typeof status.type.id !== 'undefined'
    ){
        iTypeId     = status.type.id;
    }

    // Probably not the place for this but set the short display text.
    // should be an API value for translation.
    switch (iTypeId) {
        case "3": //'final':
            time = 'FT';
            break;
        case "6": //' 'postponed':
            time = 'POST';
            break;
        case "23": //' 'halftime':
            time = 'HT';
            break;
        case "27": //' 'abandoned':
            time = 'ABD';
            break;
        case "40": //' 'walkover':
            time = 'WALK';
            break;
        case "48": //' 'fulltime':
            time = 'FT';
            break;
        default:
            // default status get the time of the event.
            if(typeof status.displayClock !== 'undefined'
            ){
                time = status.displayClock.replace(/'$/,'') + "'";
            }
    }

    return time;
};

api.getDefaultLogo = function(){
    return getLogo();
};

module.exports = api;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/helpers/utils/gameStripUtils.js
 **/